import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../redux';
import { UserContext } from '../../redux/api/types';
import utils from '../../utils';
import './group-switcher.css';

const hasCustomerGroup = (context?: UserContext | null) => {
  if (
    !context ||
    !context.customer_group_uuid ||
    context.enforce === 'customer'
  ) {
    return false;
  }

  return true;
};

function CustomerSpan() {
  const context = useSelector((state: RootState) => state.api.context);
  const data = useSelector((state: RootState) => state.api.data);

  let customer;

  if (context) {
    customer = utils.findItemByUuid(data, context.customer_uuid);
  }

  return (
    <span
      className={`customer-name ${hasCustomerGroup(context) ? 'item-name-text-ellipsis' : 'customer-only-name-text-ellipsis'}`}
    >
      {customer?.name ?? 'Customer'}
    </span>
  );
}

export default CustomerSpan;
